/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from '../../mutation-types';

const state = {
  product: {
    zones: [],
    partners: [],
  },
  coordinates: [],
  error: null,
};

const getters = {
  product: state => state.product,
  coordinates: state => state.coordinates,
  error: state => state.error,
};

const actions = {
  fetch({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    const tenant =
      payload.user.data.selectedRole.role === 'landlord'
        ? payload.id
        : payload.user.data.selectedRole.id;
    return Vue.http
      .get(
        `${process.env.BACKEND_API_URL}api/${path}/partners/${tenant}/products/${payload.id}`,
      )
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  add({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http
      .post(
        `${process.env.BACKEND_API_URL}api/${path}/partners/${payload.tenant_id}/products/${payload.product_id}/deffered`,
        {
          amount: payload.amount,
          date_application: payload.date_application,
        },
      )
      .then(() => {})
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response.data.error);
      });
  },
  delete({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http
      .delete(
        `${process.env.BACKEND_API_URL}api/${path}/partners/${payload.tenant_id}/products/${payload.product_id}/deffered/${payload.product_id}`,
        {
          product_id: payload.product_id,
        },
      )
      .then(() => {})
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response.data.error);
      });
  },
  edit({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    console.log('payload', payload);

    return Vue.http
      .put(
        `${process.env.BACKEND_API_URL}api/${path}/partners/${payload.companyId}/products/${payload.productId}/deffered/${payload.defferedId}`,
        {
          amount: payload.amount,
          date_application: payload.date_application,
        },
      )
      .then(() => {})
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response.data.error);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, product) {
    state.product = product.data;
    state.coordinates = [];
    if (state.product.zones) {
      state.product.zones.forEach((el) => {
        if (el.coordinates) {
          state.coordinates.push(el.coordinates);
        }
      });
    }
    state.error = null;
  },
  [mTypes.CLEAR_STATE](state) {
    state.product = {};
    state.coordinates = [];
  },
  [mTypes.DATA_STORED](state, product) {
    state.product = product.data;
    state.coordinates = [];
    if (state.product.zones) {
      state.product.zones.forEach((el) => {
        if (el.coordinates) {
          state.coordinates.push(el.coordinates);
        }
      });
    }
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/tenants/productDelayed.js